import React from "react";
import "./Feature.css";

const Feature = () => {
  return (
    <section className="bg-gradient-to-r from-primary to-secondary">
      <div className="container grid lg:grid-cols-3 grid-cols-1 py-6 gap-8 text-white">
        {/* Feature 1 - Zahnimplantate */}
        <article className="flex lg:py-8 feature-section">
          <div aria-hidden="true">
            <i className="fas fa-teeth-open text-6xl py-6 px-4"></i>
          </div>
          <div>
            <h2 className="text-md pb-2 uppercase font-bold leading-snug text-white hover:opacity-75">
              Zahnimplantate
            </h2>
            <p>
              Zahnimplantate bieten Ihnen die beste Möglichkeit, gesunde,
              schöne und natürliche Zähne zu erhalten.
            </p>
          </div>
        </article>

        <div className="block lg:hidden divider-horizontal"></div>

        {/* Feature 2 - Parodontose-Behandlung */}
        <article className="flex lg:px-8 lg:py-8 pl-4 feature-section">
          <div aria-hidden="true">
            <i className="fas fa-tooth text-6xl py-6 px-4"></i>
          </div>
          <div>
            <h2 className="text-md pb-2 uppercase font-bold leading-snug text-white hover:opacity-75">
              Parodontose-Behandlung
            </h2>
            <p>
              Eine rechtzeitig diagnostizierte und behandelte Parodontose kann
              Sie vor Zahnverlust bewahren.
            </p>
          </div>
        </article>

        <div className="block lg:hidden divider-horizontal"></div>

        {/* Feature 3 - Zahnaufhellung */}
        <article className="flex lg:px-8 lg:py-8 feature-section">
          <div aria-hidden="true">
            <i className="fas fa-teeth text-6xl py-6 px-4"></i>
          </div>
          <div>
            <h2 className="text-md pb-2 uppercase font-bold leading-snug text-white hover:opacity-75">
              Zahnaufhellung
            </h2>
            <p>
              Unsere Zahnaufhellung sorgt für ein strahlendes Lächeln, indem
              sie Flecken und Verfärbungen entfernt.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Feature;